<script setup>
  import {ref} from "vue";

  const props = defineProps({
    src: {
      required: true,
      type: [String, null],
    },
    alt: {
      required: false,
      type: String,
      default: '',
    },
  });

  const hasImage = ref(props.src !== null);
</script>

<template>
  <div
    class="tw-h-40 tw-aspect-4/3 tw-overflow-hidden hover:tw-shadow-blue tw-cursor-pointer"
  >
    <img
      v-if="hasImage"
      :src="src"
      :alt="alt"
      class="tw-h-40 tw-aspect-4/3 tw-object-cover tw-overflow-hidden"
      @error="hasImage = false"
    >
    <svg-vue
      v-else
      icon="illustrations/no-image"
      class="tw-h-40 tw-aspect-4/3"
    />
  </div>
</template>
